import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import adverts from '../../../components/Ads/ManageBriefsBanner/BannerData';
import ManageBriefsBannerAd from '../../../components/Ads/ManageBriefsBanner/ManageBriefsBannerAd';

const ManageBriefsBanner = ({ partners, loadedPartners }) => {
  const [advert, setAdvert] = useState(null);

  useEffect(() => {
    if (loadedPartners) {
      getAdvert();
    }
  }, [loadedPartners]);

  const getAdvert = () => {
    const advertArray =
      partners.length > 0 ? partners : adverts.businessToolkit;
    //set initial random index before changing array based on location
    const randomNumber = Math.floor(Math.random() * advertArray.length);

    setAdvert(advertArray[randomNumber]);
  };

  return <ManageBriefsBannerAd advert={advert} />;
};

ManageBriefsBanner.propTypes = {
  partners: PropTypes.array,
  loadedPartners: PropTypes.bool,
};

export default ManageBriefsBanner;
